// extracted by mini-css-extract-plugin
module.exports = {"bodyStyle":"_2nXf-","footer":"_12d6R","clearBtn":"_3L7DC","confirmBtn":"_3wBXQ","filterCollapse":"_2GHwF"};